<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useMapGetter, useStoreGetters } from 'dashboard/composables/store';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useI18n } from 'vue-i18n';

const uiFlags = useMapGetter('accounts/getUIFlags');
const getters = useStoreGetters();
const store = useStore();
const router = useRouter();
const { t } = useI18n();

const blockedDomains = computed(
  () => getters['blockedDomains/getBlockedDomains'].value
);

const openBlockedContacts = () => {
  const filterPayload = [
    {
      attribute_key: 'blocked',
      filter_operator: 'equal_to',
      values: {
        id: 'true',
        name: t('CONTACTS_LAYOUT.FILTER.BLOCKED_TRUE'),
      },
      query_operator: 'and',
      attribute_model: 'standard',
    },
  ];

  // Navigate to contacts page with blocked filter applied
  router.push({
    name: 'contacts_dashboard_index',
    query: {
      payload: JSON.stringify(filterPayload),
    },
  });
};

onMounted(() => {
  store.dispatch('blockedDomains/get');
});
</script>

<template>
  <SettingsLayout
    :is-loading="uiFlags.isFetching"
    :no-records-found="!blockedDomains.length"
    :no-records-message="$t('BLOCKED_DOMAINS_SETTINGS.NO_BLOCKED_DOMAINS')"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('BLOCKED_DOMAINS_SETTINGS.HEADER')"
        :description="$t('BLOCKED_DOMAINS_SETTINGS.DESCRIPTION')"
        feature-name="blocked-domains"
      >
        <template #actions>
          <Button
            icon="i-lucide-contact"
            :label="$t('BLOCKED_DOMAINS_SETTINGS.BLOCKED_CONTACTS_BTN')"
            @click="openBlockedContacts"
          />
        </template>
      </BaseSettingsHeader>
    </template>
    <template #body>
      <div class="w-full">
        <div
          class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden"
        >
          <div class="divide-y divide-slate-200 dark:divide-slate-700">
            <div
              v-for="(entry, index) in blockedDomains"
              :key="index"
              class="px-6 py-4 flex items-center justify-between hover:bg-slate-50 dark:hover:bg-slate-700"
            >
              <div class="flex items-center gap-3">
                <div>
                  <p
                    class="text-sm font-medium text-slate-900 dark:text-slate-100"
                  >
                    {{ entry.domain }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SettingsLayout>
</template>
